import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { PolicySummary } from '../../models/policies.model';
import {
	deleteOrgPolicyStart,
	deleteStepClear,
	fetchOrgPoliciesStart,
} from '../../state/organizations.actions';
import {
	selectDeleteStep,
	selectOrgLoading,
	selectPolicies,
} from '../../state/organizations.selector';

@Component({
	selector: 'app-del-policy-dialog',
	template: `
		<app-dialog
			modalTitle="Atenção"
			titleButton="Sim"
			secTitleButton="Não"
			[secButton]="true"
			[asAlert]="true"
			(dialogClose)="dialogRef.close(false)"
			(dialogSave)="dialogRef.close(true)"
		>
			<p class="lh-md">
				A exclusão dessa política pode afetar alguns beneficiários que possuem
				esta política. Tem certeza que deseja continuar?
			</p>
		</app-dialog>
	`,
})
export class DelPolicyDialogComponent {
	constructor(public dialogRef: MatDialogRef<DelPolicyDialogComponent>) {}
}

@Component({
	selector: 'app-policies',
	styleUrls: ['./policies.component.scss'],
	templateUrl: './policies.component.html',
})
export class PoliciesComponent implements OnInit, OnDestroy {
	alertRef!: MatDialogRef<DelPolicyDialogComponent>;
	loading: boolean = true;
	loading$: Observable<boolean>;
	policies: PolicySummary[] = [];
	policiesTabs = [
		{ label: 'Saúde', path: 'health' },
		{ label: 'Dental', path: 'dental' },
	];

	selectedType: 'dental' | 'health' = 'health';
	private orgId: string = '';

	private readonly unsubscribe$: Subject<void> = new Subject();

	constructor(
		private readonly router: Router,
		private readonly activatedRoute: ActivatedRoute,
		private readonly dialog: MatDialog,
		private readonly store: Store,
	) {
		this.loading$ = this.store.select(selectOrgLoading);
	}

	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

	ngOnInit(): void {
		this.activatedRoute.params.subscribe(({ id }) => {
			if (id) {
				this.orgId = id;
				this.store.dispatch(
					fetchOrgPoliciesStart({ id: this.orgId, policyType: 'health' }),
				);
				this.store
					.select(selectPolicies)
					.pipe(takeUntil(this.unsubscribe$))
					.subscribe((policies) => {
						if (policies) {
							this.policies = policies;
							this.loading = false;
						}
					});
			}
		});
	}

	onDeletePolicy(id: string): void {
		this.alertRef = this.dialog.open(DelPolicyDialogComponent, {
			disableClose: true,
			maxWidth: undefined,
		});
		this.alertRef.afterClosed().subscribe((result) => {
			if (result) {
				this.store
					.select(selectDeleteStep)
					.pipe(takeUntil(this.unsubscribe$))
					.subscribe((step) => {
						if (step === 1) {
							this.store.dispatch(deleteStepClear());
							this.store.dispatch(
								fetchOrgPoliciesStart({
									id: this.orgId,
									policyType: this.selectedType,
								}),
							);
						}
					});
				this.store.dispatch(deleteOrgPolicyStart({ id, orgId: this.orgId }));
			}
		});
	}

	onEditPolicy(id: string): void {
		if (this.orgId) {
			this.router.navigateByUrl(
				`organizacoes/${this.orgId}/politicas/${this.selectedType}/${id}`,
			);
		}
	}

	onTabClick(policyType: string): void {
		if (!(policyType !== 'health' && policyType !== 'dental')) {
			this.selectedType = policyType;
			this.loading = true;
			this.store.dispatch(
				fetchOrgPoliciesStart({ id: this.orgId, policyType }),
			);
		}
	}
}
